import React from 'react';
import PropTypes from 'prop-types';

const PlayerHeader = ({displayName, avatar, countryName, countryFlag}) => {
    return (
        <div className="playerHeader">
            <div className="headerRow">
                <h1>{displayName}</h1>
                <img src={avatar} alt={displayName}/>
            </div>

            <div className="headerRow">
                <img className="countryImg" src={countryFlag} alt={countryName}/>
                <h1>{countryName}</h1>
            </div>
        </div>
    )
}

PlayerHeader.propTypes = {
    displayName: PropTypes.string,
    avatar: PropTypes.string,
    countryName: PropTypes.string,
    countryFlag: PropTypes.string
}

export default PlayerHeader
